export default {"src":"/pro/_next/static/media/xpl.c8eca084.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};